module.exports = __webpack_public_path__ + "img/DE00836.15dbdf20.png";